import ApiService from "@/core/services/api.service";

// action types
export const FETCH_DEVICES = "fetchDevices";
export const FETCH_DEVICE = "fetchDevice";
export const UPDATE_DEVICE_STATUS = "updateDeviceStatus";

// mutation types
export const SET_DEVICES = "setDevices";
export const SET_DEVICES_PAGINATION = "setDevicesPagination";
export const SET_DEVICE = "setDevice";

const state = {
  devices: [],
  devicesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  device: {},
  deviceTypes: [1, 2, 3, 4],
  typesEnum: {
    1: "ECS1", // Evaporative Cooler Switch (Model 1)
    2: "TP1",
    3: "TP2",
    4: "TP4",
    5: "PR1",
    6: "VLV",
    7: "RGB",
    8: "TEP"
  },
  typesTrans: {
    1: "کلید کولر",
    2: "پنل لمسی تک پل",
    3: "پنل لمسی دو پل",
    4: "پنل لمسی چهار پل",
    5: "پریز تکی",
    6: "شیر گاز",
    7: "لامپ RGB",
    8: "دماسنج"
  }
};

const getters = {
  devices(state) {
    return state.devices;
  },
  devicesPagination(state) {
    return state.devicesPagination;
  },
  device(state) {
    return state.device;
  },
  deviceTypes(state) {
    return state.deviceTypes;
  },
  typesTrans(state) {
    return state.typesTrans;
  }
};

const actions = {
  [FETCH_DEVICES](context, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("devices", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_DEVICES, data.data);
          context.commit(SET_DEVICES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_DEVICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("devices", id)
        .then(({ data }) => {
          context.commit(SET_DEVICE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_DEVICE_STATUS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`devices/${payload.id}/status`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_DEVICES](state, devices) {
    state.devices = devices;
  },
  [SET_DEVICES_PAGINATION](state, data) {
    state.devicesPagination = data;
  },
  [SET_DEVICE](state, device) {
    state.device = device;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
